export default "__VITE_ASSET__2ea741b7__"